import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Select, DatePicker} from 'antd';
import {ExTable} from 'icsoc-antd-ex';
import UnionSearch from 'Components/union/unionSearch';
import tListActions from 'Actions/taskManage/list';
import tDetailActions from 'Actions/taskManage/detail';
import moment from 'moment';

const {
  Filter,
  Filter: {NormalFilter},
} = ExTable;
const {Option} = Select;
const {RangePicker} = DatePicker;

class Search extends UnionSearch {
  componentDidMount() {
    const {actions, tDetActions} = this.props;

    // 获取任务名称，话术名称下拉框
    actions.getWordStrategyIdOptions();
    tDetActions.getTaskNameOptions();
  }

  // 点击查询
  handleFilter = fields => {
    const {taskName, taskCommitDate, ...otherFields} = fields;
    const taskCommitDateStart =
      taskCommitDate && taskCommitDate.length
        ? taskCommitDate[0].format('x')
        : undefined;
    const taskCommitDateEnd =
      taskCommitDate && taskCommitDate.length
        ? taskCommitDate[1].format('x')
        : undefined;
    const params = {
      ...otherFields,
      taskCommitDateStart,
      taskCommitDateEnd,
      taskName: taskName && taskName.trim(),
    };

    this.onOk(params);
  };

  render() {
    const {wordStrategyIdOptions, taskNameOptions} = this.props;
    return (
      <Filter handleFilter={this.handleFilter}>
        <NormalFilter>
          {/* <NormalFilter.Item label="任务名称" field="taskName">
            <Input placeholder="请输入任务名称" maxLength="20" />
          </NormalFilter.Item> */}
          <NormalFilter.Item label="任务名称" field="taskName">
            <Select
              showSearch
              allowClear
              placeholder="请选择任务"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }>
              {Array.isArray(taskNameOptions)
                ? taskNameOptions.map(({taskId, taskName}) => (
                    <Option value={taskName} key={taskId}>
                      {taskName}
                    </Option>
                  ))
                : null}
            </Select>
          </NormalFilter.Item>
          <NormalFilter.Item label="话术名称" field="wordStrategyId">
            <Select placeholder="请选择">
              <Option value={-1}>全部</Option>
              {Array.isArray(wordStrategyIdOptions)
                ? wordStrategyIdOptions.map(({id, strategyName}) => (
                    <Option value={id && parseInt(id, 10)} key={id}>
                      {strategyName}
                    </Option>
                  ))
                : null}
            </Select>
          </NormalFilter.Item>
          <NormalFilter.Item label="提交时间" field="taskCommitDate">
            <RangePicker
              placeholder={['开始日期', '结束日期']}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  moment('00:00:00', 'HH:mm:ss'),
                  moment('23:59:59', 'HH:mm:ss'),
                ],
              }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </NormalFilter.Item>
        </NormalFilter>
      </Filter>
    );
  }
}

const mapStateToProps = ({taskManageList, taskManageDetail}) => ({
  wordStrategyIdOptions: taskManageList.wordStrategyIdOptions,
  searchData: taskManageList.searchData,
  pageStatus: taskManageList.pageStatus,
  taskNameOptions: taskManageDetail.taskNameOptions,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tListActions, dispatch),
  tDetActions: bindActionCreators(tDetailActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Search);
